import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '../tools/withStyles';
import { Secuence } from '../components/Secuence';
import { Brand } from '../components/Brand';
import { Menu } from '../components/Menu';
import { SocialLinks } from '../components/SocialLinks';
import { Legal } from '../components/Legal';
import { SearchModal } from '../components/SearchModal';

const styles = theme => {
  return {
    root: {
      margin: 'auto',
      width: '100%'
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      margin: [0, 'auto'],
      padding: 20
    },
    brand: {
      margin: [0, 'auto', 4],
      padding: [0, 0, 2],
      width: '100%',
      maxWidth: 780
    },
    menu: {
      margin: [0, 'auto', 14],
      width: '100%',
      maxWidth: 520
    },
    social: {
      margin: [0, 'auto'],
      width: '100%',
      maxWidth: 300
    },
    legal: {
      position: 'absolute',
      left: '50%',
      bottom: 0,
      transform: 'translateX(-50%)',
      zIndex: 50,
      '@media (max-width: 768px)': {
        top: 14,
        bottom: 'auto',
        left: '50%',
        right: 'auto',
        transform: 'translateX(-50%)'
      }
    }
  };
};

class Component extends React.Component {
  onLinkStart = (event, { isInternal }) => {
    if (isInternal) {
      this.secuenceElement.exit();
    }
  }

  onLogoClick = (event) => {
    if (event) {
      event.preventDefault();
    }

    if (typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent('open-search'));
    }
  }

  render () {
    const { classes } = this.props;

    return (
      <Secuence ref={ref => (this.secuenceElement = ref)}>
        <div className={classes.root}>
          <div className={classes.content}>
            <Brand
              className={classes.brand}
              onClick={this.onLogoClick}
              onLinkStart={this.onLinkStart}
            />
            <Menu
              className={classes.menu}
              animation={{ duration: { enter: 400 } }}
              scheme='expand'
              onLinkStart={this.onLinkStart}
            />
            <SocialLinks
              className={classes.social}
              onLinkStart={this.onLinkStart}
            />
          </div>
          <Legal
            className={classes.legal}
            opaque
            onLinkStart={this.onLinkStart}
          />
          <SearchModal />
        </div>
      </Secuence>
    );
  }
}

Component.propTypes = {
  classes: PropTypes.any.isRequired
};

export default withStyles(styles)(Component);

// Commit trace: 2025-07-13T06:25:02 - docs: update docstrings in index.js

// Commit trace: 2025-10-28T13:44:35 - feat: introduce dynamic logic to index.js

// Commit trace: 2025-12-21T03:31:58 - docs: improve documentation in index.js

// Commit trace: 2025-12-31T21:36:34 - docs: clarify parameter types in index.js
